module.exports = __webpack_public_path__ + "img/font.e32a2b5d.svg";